import React, { useState, useEffect, Suspense } from 'react'; // Suspense ensures that lazy-loaded components render correctly. lazy components come from ./routes
import { Route, Routes, Link } from 'react-router-dom';
import routes from "./routes";
import ServitechLogoColor from './icons/ServiTechColor.svg'

import 'bootstrap/dist/css/bootstrap.min.css'
import './styles.css'
import LoginComponent from './LoginComponent';
import config from './config';

// const managerGql = 'https://asset-employee-gql-bjudfyf5za-uc.a.run.app/graphql'
const managerGql = config.urls.asset_employee_gql_url
// const managerGql = 'http://localhost:4000/graphql'

const AppWrapper = () => {

    const [userEmail, setUserEmail] = useState("");
    const [userToken, setUserToken] = useState("");
    const [userAccessDenied, setUserAccessDenied] = useState(false);
    const [loggedIn, setLoggedIn] = useState(false)

    const handleLogOut = async (e) => {
        if (e) {
            e.preventDefault()
        }
        clearEmailToken()
        clearAccessToken()
    }

    const getEmail = () => {
        const email = localStorage.getItem('email');
        return (email);
    }
    const setEmail = (email) => {
        localStorage.setItem('email', email);
        setUserEmail(email);
    }

    const clearEmailToken = () => {
        localStorage.removeItem('email');
        setUserEmail("");
    }

    const getAccessToken = () => {
        const token = localStorage.getItem('token');
        return (token);
    }
    const setAccessToken = (token) => {
        localStorage.setItem('token', token);
    }

    const clearAccessToken = () => {
        localStorage.removeItem('token');
        setUserToken("")
    }

    const email = getEmail();
    const token = getAccessToken();


    useEffect(() => {
        if (token) {
            setUserToken(token);
        }
    }, [token]);

    useEffect(() => {
        if (email) {
            setUserEmail(email);
        }
    }, [email]);

    useEffect(() => {
        if (userEmail && userToken) {
            setLoggedIn(true)
        }
    }, [userEmail, userToken])


    return (
        <div style={{ height: "100vh" }}>
            <nav className="navbar ST-navbar fixed-top">
                <div className="container-fluid">
                    <div>
                        {/* eslint-disable-next-line */}
                        <a className="navbar-brand me-0" href="#"><img src={ServitechLogoColor} height="35px" /></a>
                    </div>
                    <div className="service-title">Vehicle Incident Form</div>
                    <div className="pe-0">
                        {/* eslint-disable-next-line */}
                        <a className="navbar-nav" data-bs-toggle="dropdown">
                            <i className="bi bi-three-dots" style={{ "fontSize": "1.5rem", "color": "#000000", "cursor": "pointer" }}></i>
                        </a>
                        <ul className="me-0 dropdown-menu dropdown-menu-end">

                            <li><a className="dropdown-item" href="https://employee-directory-bjudfyf5za-uc.a.run.app/">Employee Directory</a></li>
                            <li><a className="dropdown-item" href="https://cropfile.servitech.com">The Crop File</a></li>
                            <li><a className="dropdown-item" href="https://labreports.servitechlabs.com/">Lab Reports</a></li>
                            <li><a className="dropdown-item" href="https://intranet.servitech.com">ServiTech Intranet</a></li>

                            {loggedIn &&
                                <>
                                    <li><hr className="dropdown-divider" /></li>

                                    <li className="dropdown-item" onClick={(e) => { handleLogOut(e); setUserAccessDenied(false) }}><Link to="/login" style={{ color: "black", textDecoration: "none" }}>Logout</Link></li>
                                </>
                            }
                        </ul>
                    </div>
                </div>
            </nav>
            <div className="content-routes">
                <Suspense fallback={<div>Loading...</div>}> {/* <-- this line prevents React from throwing an error while waiting for the import to resolve. */}
                    <Routes>
                        {routes.map(({ path, component: Component }) =>
                        (
                            <Route key={path} path={path} element={(userEmail && userToken) ? <Component
                                setEmail={setEmail}
                                setAccessToken={setAccessToken}
                                getEmail={getEmail}
                                getAccessToken={getAccessToken}
                                email={email}
                                setUserAccessDenied={setUserAccessDenied}
                                handleLogOut={handleLogOut}
                            /> : <LoginComponent
                                setEmail={setEmail}
                                setAccessToken={setAccessToken}
                                getEmail={getEmail}
                                getAccessToken={getAccessToken}
                                userAccessDenied={userAccessDenied}
                                setUserAccessDenied={setUserAccessDenied}
                            />} />
                        )
                        )}
                    </Routes>
                </Suspense>
            </div>
        </div>
    );
}

export default AppWrapper;
